import { render, staticRenderFns } from "./SubmissionHoldReservation.vue?vue&type=template&id=93232594&scoped=true&"
import script from "./SubmissionHoldReservation.vue?vue&type=script&lang=js&"
export * from "./SubmissionHoldReservation.vue?vue&type=script&lang=js&"
import style0 from "./SubmissionHoldReservation.vue?vue&type=style&index=0&id=93232594&prod&lang=scss&scoped=true&"
import style1 from "./SubmissionHoldReservation.vue?vue&type=style&index=1&id=93232594&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93232594",
  null
  
)

export default component.exports